import { useQuery } from "@tanstack/react-query"
import { AvailableAxiosInstances, instanceMap } from "utils/request"

type Props = {
  url: string
  body?: any
  instanceKey: AvailableAxiosInstances
  queryKey?: readonly unknown[]
  [key: string]: any
}

export function useGet<T>({
  url,
  body,
  instanceKey,
  queryKey = [url],
  ...rest
}: Props) {
  const query = useQuery<T>({
    queryKey: queryKey,
    queryFn: async () => {
      const axiosInstanceToUse = instanceMap[instanceKey]
      const res = await axiosInstanceToUse.get(url, body)

      return res.data
    },
    refetchOnWindowFocus: false,
    cacheTime: 24 * 60 * 60 * 1000, // 1 day in milliseconds
    ...rest,
  })

  return query
}

export function usePost<T>({
  url,
  body,
  instanceKey,
  queryKey = [url],
  ...rest
}: Props) {
  const { isLoading, data, isError, refetch, isFetching } = useQuery<T>({
    queryKey,
    queryFn: async () => {
      const axiosInstanceToUse = instanceMap[instanceKey]
      const res = await axiosInstanceToUse.post(url, {
        ...body,
      })
      return res.data
    },
    refetchOnWindowFocus: false,
    cacheTime: 24 * 60 * 60 * 1000, // 1 day in milliseconds
    keepPreviousData: true,
    ...rest,
  })

  return { isLoading, data, isError, refetch, isFetching }
}
